import React from 'react';
import { Dialog } from '@mui/material';
import TokenContainer from 'js/components/token/TokenContainer';
import { Stack } from 'new/elements/Stack';

interface DialogSessionTokenProps {
  open: boolean;
  onClose: (event: any, reason: string) => void;
  showImpersonatedUser?: boolean;
}

export const DialogSessionToken = (props: DialogSessionTokenProps) => {
  const { open, onClose, showImpersonatedUser } = props;
  return (
    <Dialog onClose={onClose} open={open}>
      <Stack padding="16px">
        <TokenContainer onlyContent showImpersonatedUser={showImpersonatedUser} />
      </Stack>
    </Dialog>
  );
};
